import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Users } from 'lucide-react';
import type { ApprovalWorkflow } from '../types';

interface WorkflowStatsCardsProps {
  filteredApprovals: ApprovalWorkflow[];
  allApprovals: ApprovalWorkflow[];
}

export const WorkflowStatsCards: React.FC<WorkflowStatsCardsProps> = ({
  filteredApprovals,
  allApprovals,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Active Workflows</p>
            <p className="text-2xl font-bold">
              {filteredApprovals.filter((a) => a.status === 'Active').length}
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              of {allApprovals.filter((a) => a.status === 'Active').length} total
            </p>
          </div>
          <div className="h-12 w-12 rounded-full bg-green-100 flex items-center justify-center">
            <div className="h-6 w-6 rounded-full bg-green-500" />
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Inactive Workflows</p>
            <p className="text-2xl font-bold">
              {filteredApprovals.filter((a) => a.status === 'Inactive').length}
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              of {allApprovals.filter((a) => a.status === 'Inactive').length} total
            </p>
          </div>
          <div className="h-12 w-12 rounded-full bg-yellow-100 flex items-center justify-center">
            <div className="h-6 w-6 rounded-full bg-yellow-500" />
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Total Employees</p>
            <p className="text-2xl font-bold">
              {filteredApprovals.reduce((sum, a) => sum + a.assignedEmployees, 0)}
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              of {allApprovals.reduce((sum, a) => sum + a.assignedEmployees, 0)} total
            </p>
          </div>
          <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center">
            <Users className="h-6 w-6 text-blue-500" />
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
);
